import React from 'react';
import PropTypes from 'prop-types';
import {Button, Icon, Dropdown, DropdownItem} from '@albert-io/atomic';
import ManageRosterContext from 'client/Classrooms/Classroom/Teacher/ManageRoster/ManageRoster.context';
import HardCapWarningBanner from 'client/components/HardCapWarningBanner/HardCapWarningBanner.react';

/**
 * InviteDropdownBtn
 * =================
 *
 * At first glance, it might look like this returns a <Dropdown /> instance, but the rendered component is
 * actually the button that we pass to the Dropdown's "trigger" prop via getTriggerBtn().
 *
 * Accordingly, this component is meant to consume any props that <Button /> would expect.
 */

export default class InviteDropdownBtn extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    triggerBtn: PropTypes.node,
    shouldDisplayHardCapMessage: PropTypes.bool,
    hardCapSeatsRemaining: PropTypes.number
  };

  static contextType = ManageRosterContext;

  getTriggerBtn = () => {
    const {className, triggerBtn, ...rest} = this.props;
    if (triggerBtn) {
      return triggerBtn;
    }
    return (
      <Button className={className} {...rest}>
        <Icon className='u-mar-r_1' icon='user-plus' iconStyle='light' />
        Invite students
      </Button>
    );
  };

  render() {
    const {setModalToShow} = this.context;
    const {shouldDisplayHardCapMessage, hardCapSeatsRemaining} = this.props;

    return (
      <Dropdown
        className='u-flex-grow_1'
        fillWrapper
        position='bottom-start'
        positionFixed
        trigger={this.getTriggerBtn()}
        wrapperClassName='u-display_flex u-flex-grow_1'
      >
        {shouldDisplayHardCapMessage && (
          <DropdownItem bold={false} className='u-pad_0' noWrap={false}>
            <HardCapWarningBanner seatsRemaining={hardCapSeatsRemaining} />
          </DropdownItem>
        )}
        <DropdownItem
          as='button'
          onClick={() => setModalToShow('email')}
          subtext='Add multiple emails or upload a CSV'
        >
          Invite by email
        </DropdownItem>
        <DropdownItem as='button' onClick={() => setModalToShow('googleClassroom')}>
          Import Google Classroom
        </DropdownItem>
        <DropdownItem
          as='button'
          onClick={() => setModalToShow('classCode')}
          subtext='Students can use the class code to join this class'
        >
          Display class code
        </DropdownItem>
        <DropdownItem
          as='button'
          onClick={() => setModalToShow('LMS')}
          subtext='Import students from Canvas, Blackboard, Moodle, or Brightspace.'
        >
          Import from LMS
        </DropdownItem>
      </Dropdown>
    );
  }
}
